<template>
  <div
    v-if="hasRecentBrands"
    :class="['recent-brands', large && 'recent-brands--large']"
  >
    <BrandLink
      v-for="brand of displayBrands"
      :key="brand.id"
      :brand="brand"
      @navigate="emit('navigate')"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, Ref, ref } from 'vue'

import { getRecentBrands, Brand, BrandLink } from '@/core'

import { isDesktop } from '@/utils'

const props = withDefaults(
  defineProps<{
    large?: boolean
    limit?: number
  }>(),
  {
    large: false,
    limit: 8,
  }
)

const emit = defineEmits(['navigate'])

const recentBrands = ref<Brand[]>([]) as Ref<Brand[]>

const displayBrands = computed(() => {
  return recentBrands.value.slice(0, !isDesktop.value ? 3 : props.limit)
})

const hasRecentBrands = computed(() => {
  return displayBrands.value.length > 0
})

onMounted(() => {
  recentBrands.value = getRecentBrands()
})
</script>

<style lang="scss" scoped>
.recent-brands {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(1, minmax(0, 1fr));

  @include respond-to('md-and-up') {
    gap: 16px;
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  &--large {
    @include respond-to('md-and-up') {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }
}
</style>
